import { SetXrayMode } from '../engine/state/engine.actions';
import { Store } from '@ngxs/store';
import { EngineService } from '../engine/engine.service';
import { EventsEnum } from '../engine/models/events.enum';

export function disableXrayMode(store: Store, engineService: EngineService): true {
  store.dispatch(new SetXrayMode(false));
  engineService.fireEvent(EventsEnum.SceneXrayDisabled, undefined);
  return true;
}
